module.exports = __webpack_public_path__ + "static/media/health.4d3b3598.png";